import { User } from '@core/models/user.model';
import { Selector } from '@ngxs/store';
import { UserState, UserStateModel } from './user.state';

export class UserSelectors {
  @Selector([UserState])
  static getUser(state: UserStateModel): User {
    return state.user;
  }

  @Selector([UserSelectors.getUser])
  static userId(user: User): string {
    return user.sub;
  }

  @Selector([UserSelectors.getUser])
  static userRoles(user: User): string[] {
    const roles = Array.isArray(user.role) ? user.role : [user.role];
    return roles;
  }

  @Selector([UserSelectors.userRoles])
  static isCompetitionAdmin(roles: string[]): boolean {
    return roles.includes('SalesOrderEvents.RuleAdmin');
  }

  @Selector([UserState])
  static isAuthenticated(state: UserStateModel): boolean {
    return state.isAuthenticated;
  }
}
